import { AppModule } from '@core/modules/app/app.module'
import { Analytics } from '@core/services/mixpanel'
import { clsx } from 'clsx'
import { FC, useMemo } from 'react'
import { Left, TopSectionWrapper } from './topSection.styles'
import Typography from '@/ui/components/typography'
import { IssuesStats } from '@/ui/components/IssuesStats'
import { UsersModule } from '@/core/modules/users'
import { AssetsModule } from '@/core/modules/digital-footprint/assets'

type TopSectionTitleSubtitle = {
    title: string
    subtitle: string
}

const TopSection: FC = () => {
    const titleSubtitleWithIntegration: TopSectionTitleSubtitle = {
        title: 'Fraud Defense Email Security',
        subtitle:
            'At-Bay Stance Fraud Defense monitors emails to detect fraud, phishing, and impersonation.',
    }
    const { title, subtitle } = titleSubtitleWithIntegration

    const allFdIssues = UsersModule.getFdIssues({ disableFilters: true })
    const usersAssets = AssetsModule.getUsersAssetsWithFdIssues()

    return (
        <TopSectionWrapper>
            <Left>
                <div>
                    <Typography
                        variant="xl-regular"
                        testId="fraud-defense-page-title"
                    >
                        {title}
                    </Typography>
                    <Typography variant="s-regular">{subtitle}</Typography>
                </div>
            </Left>
            <IssuesStats
                leftCount={usersAssets.length}
                leftDescription="Affected Users"
                rightCount={allFdIssues.length}
                rightDescription="Open Issues"
            />
        </TopSectionWrapper>
    )
}

export default TopSection
